import { createSlice } from "@reduxjs/toolkit";
import productListReducers from "./reducers";
import { ProductListState } from "./types";

export const initialState: ProductListState = {};
const productListSlice = createSlice({
  name: "productList",
  initialState,
  reducers: productListReducers,
});

const { actions } = productListSlice;
export { actions };

export default productListSlice;
